import { createRoute, Outlet, redirect } from '@tanstack/react-router'
import { managementLayoutRoute } from '@/ui/pages/management'
import { useAuthStore } from '@/application/stores/auth.store'

export const commentsRoute = createRoute({
  getParentRoute: () => managementLayoutRoute,
  path: 'comments',
  beforeLoad: () => {
    const { user } = useAuthStore.getState()
    const canAccess =
      user?.role === 'streamer' || user?.role === 'moderator' || user?.role === 'admin'
    if (!canAccess) throw redirect({ to: '/manage/profile' })
  },
  component: CommentsLayout,
})

export function CommentsLayout() {
  return <Outlet />
}
